// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueLodash from 'vue-lodash'
const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional
// import skelet component
import MainApp from './MainApp'
import router from './router'
// import Firebase
import Firebase from 'firebase'
// import VueFire
import VueFire from 'vuefire';
Vue.use(VueFire);
// initialize Firebase database
import {firebaseDB} from '@/firebase';
import moment from "moment";
/* import styles */
import './assets/css/main-styles.css'
import './assets/css/font-awesome.css'
import './assets/css/dosis-webfont.css'
/* import moment for Date/Time manipulation */
//import moment from 'moment'

Vue.config.productionTip = false
// create variable that will hold our application
let app;
// let config = {
//   apiKey: "AIzaSyAX6-DkEsIkpHzQRSXfWOUZ7XkJuhj4hPU",
//   authDomain: "reservationapp-7ee8b.firebaseapp.com",
//   databaseURL: "https://reservationapp-7ee8b.firebaseio.com",
//   storageBucket: "reservationapp-7ee8b.appspot.com",
//   messagingSenderId: "319067708096"
// };

//firebase.initializeApp(config)
// firebase.auth().onAuthStateChanged( (user) => {
//   if (user) {
//     // User is signed in.
//     console.log('!important onAuthStateChanged ON !!!!');
//     console.log('auth() user: ' + JSON.stringify(user, null, 2) );   
//     if (!app) {
//       /* eslint-disable no-new */
//       app = new Vue({
//         el: '#app',
//         template: '<App/>',
//         components: { App },
//         router
//       })
//     }    
//   } else {
//     // No user is signed in.
//     console.log('!important onAuthStateChanged OFF !!!!');
//     router.replace('/')
//   }
// }); 
Firebase.auth().onAuthStateChanged(function(user) {
  //console.log('auth() user: ' + JSON.stringify(user, null, 2));
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#cid-res-app-wrap',
      template: '<MainApp/>',
      components: { MainApp },
      router,
      data () {
        return {
          testMsg: 'main.js-file-right-here',
        }
      },
      created: function () {
        console.log('||-created: main.js');
        moment.updateLocale('en', {
          weekdays : ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"],
          weekdaysShort : ["Ned", "Pon", "Uto", "Sre", "Čet", "Pet", "Sub"],
          months : ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
          monthsShort : ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"]
        });        
      }
    })
  }
});



// Firebase.auth().onAuthStateChanged(function(user) {
//   console.log('auth() user: ' + JSON.stringify(user, null, 2));
//   console.log('app: ' + JSON.stringify(app, null, 2));
//   if (!app) {
//     console.log('if passed');
//     /* eslint-disable no-new */
//     let main_FirebaseUserData = {
//       currentUser: null,
//       userDetails: null,
//       isOnline: false      
//     }
//     /// before we continue to our application we need to get User/Admin data from Firebase DB
//     function getFirebaseUserData () {
//       console.log('getFirebaseUserData  ');
//       main_FirebaseUserData.currentUser = Firebase.auth().currentUser;      
//       if (main_FirebaseUserData.currentUser){
//         let tmp_userDetails = firebaseDB.ref('listOfUsers/' + main_FirebaseUserData.currentUser.uid).once('value').then(
//           function(snapshot) {
//           console.log('User Details Success');
//           main_FirebaseUserData.userDetails = snapshot.val();
//           //console.log('getFirebaseUserData firebaseDB_User in MainApp: ' + JSON.stringify(main_FirebaseUserData, null, 2));
//           createApplication();
//         }.bind(this), function(error) {
//           console.log('User Details Error');
//         }.bind(this));
//       }else{
//         console.log('There is no user token')
//       }
//     }
//     getFirebaseUserData();
//     /// After we completely created data for Firebase User/Admin, we can now initialize application
//     function createApplication () {
//       app = new Vue({
//         el: '#cid-res-app-wrap',
//         template: '<MainApp/>',
//         components: { MainApp },
//         router,
//         data () {
//           return {
//             testMsg: 'main.js-file-right-here',
//             // if everything goes right, 'firebaseDB_User' will have properties as 'main_FirebaseUserData'
//             firebaseDB_User: null,
//           }
//         },
//         created: function () {
//           console.log('||-created: main.js');
//           this.firebaseDB_User = main_FirebaseUserData;
//         }
//       })
//     }
//   }
// });


// WEBPACK FOOTER //
// ./src/main.js